module.exports = "## What is an Image Compressor?\r\n\r\nIt is a free online tool provided by ImageResize.org for compressing images without losing image quality. We use the latest image compression methods and intelligent algorithms to lower your image file size. This image compressor can compress JPG and PNG images. If you have a GIF file to optimize, we recommend [GIF Compressor](https://www.gifmaker.net/compress) by GIFmaker.net"


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/what-is-image-compressor.md
// module id = 1144
// module chunks = 0